import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { musicItemType } from "../../interfaces/general";

interface AudioItemsStateInterface {
    audioItems: musicItemType[] | undefined;
    playListFeatures?: { name: string; create_at: number };
}

const audioItemsSliceState: AudioItemsStateInterface = {
    audioItems: undefined,
    playListFeatures: undefined
};

export const audioItemsSlice = createSlice({
    name: "audioItems",
    initialState: audioItemsSliceState,
    reducers: {
        setMusicItems: (state, action: PayloadAction<musicItemType[] | undefined>) => {
            state.audioItems = action.payload;
        },
        setPlayListFeatures: (state, action: PayloadAction<{ name: string; create_at: number }>) => {
            state.playListFeatures = action.payload;
        }
    }
});

export const { setMusicItems, setPlayListFeatures } = audioItemsSlice.actions;
export const selectAudioItems = (state: RootState) => state.audioItems;
export default audioItemsSlice.reducer;
